import { render } from "./RecruitInfo.vue?vue&type=template&id=7357dd4f&scoped=true&ts=true"
import script from "./RecruitInfo.vue?vue&type=script&lang=ts"
export * from "./RecruitInfo.vue?vue&type=script&lang=ts"

import "./RecruitInfo.vue?vue&type=style&index=0&id=7357dd4f&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7357dd4f"]])

export default __exports__